"use client";

import { InfoIcon } from "lucide-react";
import { Button } from "@tripcart/traveler-ui/components/button";
import { useTranslator } from "@/lib/translation-context";
import { LazyTooltip } from "@/components/lazy-floating/tooltip.client";

import styles from "./_info-tooltip.client.module.css";

export function InfoTooltip({
  description,
}: {
  description: string;
}): React.ReactElement {
  const t = useTranslator();
  return (
    <LazyTooltip
      content={description}
      contentClassName={styles.content}
      renderTrigger={(triggerProps) => (
        <Button
          variant="link"
          aria-label={t("More Information")}
          {...triggerProps}
        >
          <InfoIcon strokeWidth={2} />
        </Button>
      )}
    />
  );
}
